const { __ } = wp.i18n;

import { useEffect, useState } from "@wordpress/element";
import { API } from '../API';
import EntidadesItem from '../EntidadesItem';
import FormSearchEntidades from "../FormSearchEntidades";

function Entidades({ displaySearchForm, filterEntidades }) {

  const apiEntidades = new API({ filterEntidades });
  const defaultArgs = {
    posts_per_page: 99,
  }

  const [totalEntidades, setTotalEntidades] = useState(0);
  const [originalEntidades, setOriginalEntidades] = useState([]);
  const [entidadesQuery, setEntidadesQuery] = useState();
  const [allEntidades, setAllEntidades] = useState([]);
  
  const searchEntidades = (event) => {
    
    event.preventDefault();
    
    if (!entidadesQuery) {
      setTotalEntidades(originalEntidades.length);
      setAllEntidades(originalEntidades);
      return;
    }

    const searchQuery = { ...defaultArgs, search: entidadesQuery };

    apiEntidades.loadContent(searchQuery).then(response => {
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data)
    });

  }

  useEffect(() => {
    apiEntidades.loadContent(defaultArgs).then(response => {
      setOriginalEntidades(response.data);
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data);
    });
    
  }, []);

  return (
    <>
    
      { displaySearchForm == 'true' ? <FormSearchEntidades searchEntidades={searchEntidades} setEntidadesQuery={setEntidadesQuery} /> : '' }

      <p className="content-entidades-total pb-1 fw-700 has-text-black-500-color has-small-font-size">
        { __('Entidades', 'bizum-website') } ({totalEntidades})
      </p>

      <div className={`content-entidades-grid grid-4`}>
        {allEntidades.map(item => {
          return <EntidadesItem key={item.id} id={item.id} title={item.title} logo={item.logo} external_link={item.external_link} />
        })}
      </div>
    </>
  )

}

export default Entidades;